import { useLocation, useNavigate } from 'react-router-dom'

/**
 * 去登录页时带上「当前在哪一页」。
 *
 * LoginPage 会读 location.state.from 把用户送回去（另一路是 api.js 拦到 401 时带的
 * ?redirect=，它在组件外只能走地址栏）。调用方不传这个 state，登录完就会被丢到
 * /dashboard —— 跳转本身是成功的，所以这个缺失在页面上看不出来。
 * 见 src/test/login-return-to.test.jsx。
 *
 * 单独一个文件而不是放在 useGuest.jsx：那份同时导出 GuestPrompt / AmountDisplay 组件，
 * 组件与非组件混在一个文件会让 react-refresh 失效（eslint 的
 * react-refresh/only-export-components 就是在提示这件事）。
 */
export function useGoLogin() {
  const navigate = useNavigate()
  const location = useLocation()
  return () => navigate('/login', { state: { from: location } })
}
